import React, { useState } from 'react';
import { useApi } from '@axiom/ui';

import { AreaOfStudyApi } from '../../api/generated/area-of-study-api';
import type { AreaOfStudy } from '../../types/generated/area-of-study';

import { AdminModalSearchListDetail } from './AdminModalSearchListDetail';
import { AdminModalSearchList } from './AdminModalSearchList';
import { AdminModalDetail } from './AdminModalDetail';
import { AdminModalAreasOfStudyForm } from './AdminModalAreasOfStudyForm';

export const AdminModalAreasOfStudyView = () => {
  const [{ data: areasOfStudy }] = useApi(AreaOfStudyApi.readAreasOfStudy());
  const [selected, setSelected] = useState<Partial<AreaOfStudy> | null>(null);
  const [search, setSearch] = useState('');

  const visible = areasOfStudy
    .filter(area => area.name.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => (a.name > b.name ? 1 : -1));

  return (
    <AdminModalSearchListDetail
      name="MANAGE_AREAS_OF_STUDY"
      list={
        <AdminModalSearchList<AreaOfStudy>
          name="AREAS_OF_STUDY_LIST"
          searchName="SEARCH_INPUT"
          searchPlaceholder="Search areas of study"
          onSearchChange={setSearch}
          items={visible}
          selectedId={selected?.id ?? null}
          onSelect={setSelected}
          renderRow={area => ({ content: area.name })}
          addControl={{
            kind: 'button',
            label: 'Add Area of Study',
            name: 'ADD_AREA_OF_STUDY',
            onAdd: () => {
              setSelected({});
            },
          }}
        />
      }
      detail={
        <AdminModalDetail
          emptyText="Select an area of study."
          emptyName="NO_AREA_OF_STUDY_SELECTED"
        >
          {selected ? (
            <AdminModalAreasOfStudyForm
              name="AREAS_OF_STUDY_FORM"
              key={selected.id ?? null}
              areasOfStudy={areasOfStudy}
              selected={selected}
              onClose={() => {
                setSelected(null);
              }}
            />
          ) : null}
        </AdminModalDetail>
      }
    />
  );
};
